import React from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import "../../assets/css/library/bootstrap.min.css";
import "../../assets/css/utility/input-field.css";
import "../../assets/css/update-user-profile.css";
import ProfileInformation from "./components/UpdateProfile/ProfileInformation";
import Security from "./components/UpdateProfile/Security";
import BlockedList from "./components/UpdateProfile/BlockedList";
import ChangeSavedCard from "./components/UpdateProfile/ChangeSavedCard";

const UpdateProfile = () => {
  const location = useLocation();
  const userData = useSelector((state) => state.basicInfo?.userDetails);

  return (
    <>
      <section id="profile-update-page">
        <div className="container theme-section">
          <div className="row">
            <div className="col-lg-4">
              <div className="update-page-side-nav">
                <Link
                  className={
                    location.pathname === "/update-profile/profile-information"
                      ? "active-nav"
                      : ""
                  }
                  to="/update-profile/profile-information">
                  <i className="fa-solid fa-user"></i>
                  <div>
                    <p>Profile Information</p>
                    <span>
                      Change Or Update Your Personal Information , Bank
                      Information and Compnay Information
                    </span>
                  </div>
                </Link>
                <Link
                  to="/update-profile/security"
                  className={
                    location.pathname === "/update-profile/security"
                      ? "active-nav"
                      : ""
                  }>
                  <i className="fa-solid fa-key"></i>
                  <div>
                    <p>Security</p>
                    <span> You Can Change Or Update Your Password</span>
                  </div>
                </Link>
                {userData?.user_type === "shipper" && (
                  <Link
                    to="/update-profile/change-saved-card"
                    className={
                      location.pathname === "/update-profile/change-saved-card"
                        ? "active-nav"
                        : ""
                    }>
                    <i className="fa-regular fa-credit-card"></i>
                    <div>
                      <p>Change Saved Card</p>
                      <span>Can Update Already Saved Card</span>
                    </div>
                  </Link>
                )}
                <Link
                  to="/update-profile/blocked-list"
                  className={
                    location.pathname === "/update-profile/blocked-list"
                      ? "active-nav"
                      : ""
                  }>
                  <i className="fa-solid fa-user-minus"></i>
                  <div>
                    <p>Blocked Users</p>
                    <span>
                      When you block someone, you can not contact with him/her.
                      Here your can also unblock them.
                    </span>
                  </div>
                </Link>
              </div>
            </div>

            <Routes>
              <Route
                path="profile-information"
                element={<ProfileInformation />}
              />
              <Route path="security" element={<Security />} />
              <Route path="blocked-list" element={<BlockedList />} />
              {userData?.user_type === "shipper" && (
                <Route path="change-saved-card" element={<ChangeSavedCard />} />
              )}
            </Routes>
          </div>
        </div>
      </section>
    </>
  );
};

export default UpdateProfile;
